import React from "react";

const DownloadGraphButton = ({ chartID, myhandleExport, btndisable }) => {

  return (
    <button
      onClick={() => myhandleExport(chartID)}
      className="hide-in-pdf mb-3 dbtn px-3 py-2 text-white bg-primary rounded border-0 cursor-pointer me-3"
      type="button"
      disabled={btndisable}
    >
      Download
    </button>
  );
};

export default DownloadGraphButton;
